import { render, staticRenderFns } from "./PostGame.vue?vue&type=template&id=4f571149&scoped=true"
import script from "./PostGame.js?vue&type=script&lang=js&external"
export * from "./PostGame.js?vue&type=script&lang=js&external"
import style0 from "./PostGame.vue?vue&type=style&index=0&id=4f571149&prod&lang=scss"
import style1 from "./PostGame.vue?vue&type=style&index=1&id=4f571149&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f571149",
  null
  
)

export default component.exports